import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function trafficSource(reg) {
  if (reg.utm_source) return reg.utm_medium ? `${reg.utm_source} / ${reg.utm_medium}` : reg.utm_source;
  if (reg.fbclid) return "facebook (click id)";
  if (reg.ref_code) return "referral link";
  return "direct / organic";
}

export const isAdTagged = (reg) => Boolean(reg.utm_source || reg.fbclid);
